import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Error from '../error/Error';
import * as classes from './RadioInput.module.scss';

export const RadioGroup = forwardRef(({ className, options, label, error, ...props }, ref) => (
  <div className={className}>
    <fieldset className={classes.radioGroup}>
      <legend>{label}</legend>

      {options.map(({ value, label }) => {
        const id = `${props.name}_${value}`;

        return <RadioInput key={id} id={id} value={value} label={label} ref={ref} {...props} />;
      })}
    </fieldset>

    {error && <Error>{error?.message}</Error>}
  </div>
));
RadioGroup.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ),
  label: PropTypes.node,
  error: PropTypes.object
};

const RadioInput = forwardRef(({ id, value, label, ...props }, ref) => (
  <div className={classes.radio}>
    <input id={id} value={value} className={classes.radioInput} type="radio" ref={ref} {...props} />
    <label htmlFor={id} className={classes.radioLabel}>
      {label}
    </label>
  </div>
));
RadioInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.node
};

export default RadioInput;
